import { useEffect } from "react";

import { GlobalSearchErrorBoundary } from "./GlobalSearch.ErrorBoundary";
import { GlobalSearchModal } from "./GlobalSearchModal";
import GlobalSearchModalModel from "./GlobalSearchModal.Model";

function isSearchShortcut(event: KeyboardEvent): boolean {
  return (event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k";
}

// Mounted once in NavBarLayout — inside the Router, unlike ModalModel/SSModal.
export function GlobalSearchRoot(): React.ReactElement | null {
  const { isOpen } = GlobalSearchModalModel.useState();

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent): void {
      if (!isSearchShortcut(event)) return;
      event.preventDefault();
      GlobalSearchModalModel.open();
    }
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  if (!isOpen) return null;

  return (
    <GlobalSearchErrorBoundary>
      <GlobalSearchModal />
    </GlobalSearchErrorBoundary>
  );
}
